// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2JQ-I","container":"styles_container__1Re8W","title":"styles_title__3qkDk","wrapper":"styles_wrapper__15Oor","answer":"styles_answer__14o5o"};